<template>
    <div class="hidden items-center justify-between py-3 lg:flex">
        <div class="flex w-full items-center justify-end gap-x-3">
            <select
                id="product-sort"
                :value="selectedSort"
                @change="onSortChange"
                aria-label="Sort products"
                class="w-[200px] cursor-pointer appearance-none rounded-full border-2 border-solid border-green-600 bg-white bg-[url('/icons/chevron-down.svg')] bg-[center_right_12px] bg-no-repeat px-3 py-2 pr-8 text-sm focus:outline-none">
                <option v-for="sort in formattedSorts" :key="sort.value" :value="sort.value">
                    {{ sort.label }}
                </option>
            </select>
        </div>
    </div>
</template>

<script setup lang="ts">
    interface Sort {
        key: string;
        translated: {
            label: string;
        };
    }

    const props = defineProps({
        limit: {
            type: Number,
            default: 0,
        },
        total: {
            type: Number,
            default: 0,
        },
        sorts: {
            type: Array as () => Sort[],
            default: () => [],
        },
        currentSort: {
            type: String,
            default: '',
        },
    });

    const route = useRoute();
    const router = useRouter();
    const selectedSort = ref(typeof route.query.sort === 'string' ? route.query.sort : '');

    const formattedSorts = computed(() => {
        return props.sorts.map(sort => ({
            value: sort.key,
            label: sort.translated.label,
        }));
    });

    // When options become available, ensure selectedSort matches a valid option
    watch(
        formattedSorts,
        sorts => {
            if (sorts.length > 0 && !sorts.some(s => s.value === selectedSort.value)) {
                selectedSort.value = sorts[0].value;
            }
        },
        { immediate: true },
    );

    function onSortChange(event: Event) {
        const newSort = (event.target as HTMLSelectElement).value;
        selectedSort.value = newSort;
        router.push({
            path: route.path,
            query: {
                ...route.query,
                sort: newSort || undefined,
            },
        });
    }
</script>
